<div id="page-wrapper" >
<router-outlet></router-outlet> 
<app-footer class="mauto-top"></app-footer>
</div>